import { createPinia } from "pinia"
import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"

import "./assets/main.scss"

const app = createApp(App)
app.use(router)
app.use(createPinia())
app.mount("#app")

navigator.serviceWorker.getRegistrations().then(function (registrations) {
  for (let registration of registrations) {
    registration.unregister()
  }
})
